import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextMotion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTextMotion"><Path fillRule="evenodd" clipRule="evenodd" d="M15.5 3.55591L22.2313 19.6525L20.8474 20.2312L18.6598 14.9999H12.3402L10.1526 20.2312L8.76871 19.6525L15.5 3.55591ZM12.9675 13.4999H18.0325L15.5 7.44387L12.9675 13.4999ZM5 5.99989H11V7.49989H5V5.99989ZM2 11.2499H9V12.7499H2V11.2499ZM3 16.4999H7V17.9999H3V16.4999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextMotion;
